// Mock data for Dexbit website

export const mockLeads = [];

export const saveLead = (leadData) => {
  const newLead = {
    id: Date.now().toString(),
    ...leadData,
    createdAt: new Date().toISOString()
  };
  mockLeads.push(newLead);
  console.log('Lead saved:', newLead);
  return newLead;
};

export const getLeads = () => {
  return mockLeads;
};

// Featured properties mock data
export const featuredProperties = [
{
  id: 1,
  type: 'Residential',
  name: "Apartment Complex",
  location: 'Banjara Hills, Hyderabad',
  minInvestment: "\u20B910L",
  image: 'https://images.unsplash.com/photo-1612637968894-660373e23b03',
  status: 'Early Access'
},
{
  id: 2,
  type: 'Commercial',
  name: "Tech Park Office",
  location: "Financial District, Hyderabad",
  minInvestment: '₹15L',
  image: 'https://images.unsplash.com/photo-1574958269340-fa927503f3dd',
  status: 'Coming Soon'
},
{
  id: 3,
  type: 'Hospitality',
  name: "Boutique Hotel",
  location: "Narsingi, Hyderabad",
  minInvestment: '₹20L',
  image: 'https://images.unsplash.com/photo-1668480441891-3744c25337a3',
  status: 'Early Access'
}];


// Investment styles data
export const investmentStyles = [
{
  id: 1,
  title: 'Growth Investments',
  tag: 'Residential',
  description: 'Invest early in premium residential projects and exit with capital appreciation.',
  image: 'https://images.unsplash.com/photo-1758448511648-d7d8e1993c3f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxwcmVtaXVtJTIwcmVzaWRlbnRpYWwlMjBhcGFydG1lbnRzfGVufDB8fHx8MTc3MzkxNDY4MHww&ixlib=rb-4.1.0&q=85'
},
{
  id: 2,
  title: 'Income Investments',
  tag: 'Commercial',
  description: 'Earn steady rental income along with long-term property value growth.',
  image: 'https://images.unsplash.com/photo-1758630737900-a28682c5aa69?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjb21tZXJjaWFsJTIwb2ZmaWNlfGVufDB8fHx8MTc3MzkxNDY4M3ww&ixlib=rb-4.1.0&q=85'
},
{
  id: 3,
  title: 'Experiential Ownership',
  tag: 'Hospitality',
  description: 'Own a share in living, breathing assets like co-living and boutique hospitality spaces.',
  image: 'https://images.unsplash.com/photo-1649731000184-7ced04998f44?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwzfHxib3V0aXF1ZSUyMGhvdGVsJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzczOTE0Njg3fDA&ixlib=rb-4.1.0&q=85'
}];